import React, { Fragment } from "react";
import CheckIcon from "@mui/icons-material/Check";
import ProgressBar from "../../components/Reusable/ProgressBar";
import { useTranslation } from "react-i18next"; // Importuj useTranslation

const TaskListItem = (props) => {
  const { item } = props || {};
  const { t } = useTranslation(); // Koristi useTranslation za prevođenje

  // const status = item?.goal === item?.goalProgress ? "success" : "inprogress";

  let statusClass = "not-start";

  if (item?.goalProgress === 0) {
    statusClass = "wrong-icon-task";
  } else if (item?.goalProgress > 0 && item?.goalProgress < item?.goal) {
    statusClass = "inprogress-icon-task";
  } else if (item?.goalProgress === item?.goal) {
    statusClass = "success-icon-task";
  }

  const type = item?.type || "PRODUCT";

  return (
    <div className="task-list-item-context-list-item">
      <div className="task-list-item-context-list-item-icon">
        <CheckIcon className={statusClass} />
      </div>
      <div className="task-list-item-context-list-item-text">
        {type === "PRODUCT" ? (
          <Fragment>
            <div className="task-list-item-context-list-item-title">
              {t("taskListItem.goalProgressLabel")} <b>{item?.name}</b>
            </div>
            <ProgressBar goalProgress={item?.goalProgress} goal={item?.goal} />
          </Fragment>
        ) : type === "EDUCATION" ? (
          <Fragment>
            <div className="task-list-item-context-list-item-title">
              {t("taskListItem.finishEducationLabel")} <b>{item?.name}</b>
            </div>
            <ProgressBar goalProgress={item?.goalProgress} goal={item?.goal} />
          </Fragment>
        ) : type === "EXPERIENCE" ? (
          <Fragment>
            <div className="task-list-item-context-list-item-title">
              {t("taskListItem.goalProgressEXPLabel")}
            </div>
            <ProgressBar goalProgress={item?.goalProgress} goal={item?.goal} />
          </Fragment>
        ) : (
          <Fragment>
            <div className="task-list-item-context-list-item-title">
              {t("taskListItem.goalProgressCategoryLabel")} <b>{item?.name}</b>
            </div>
            <ProgressBar goalProgress={item?.goalProgress} goal={item?.goal} />
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default TaskListItem;
